// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as PretendAsCallerDashboardCmp from "./PretendAsCallerDashboardCmp.bs.js";

function PretendAsCallerDashboardContainer(Props) {
  var phone_number = Props.phone_number;
  return React.createElement(PretendAsCallerDashboardCmp.make, {
              phone_number: phone_number
            });
}

var make = PretendAsCallerDashboardContainer;

export {
  make ,
  
}
/* react Not a pure module */
